// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2229o","content":"LayoutSettings_content__1ZECi"};